import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { ApiResponse } from '../models';

import { AUTH_CONSTS } from '../store/auth/auth.consts';

export class ApiService {

  protected readonly REQUEST_HEADERS = {
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type'
  };

  protected readonly CONTENT_TYPES = {
    JSON: 'application/json'
  };

  constructor(protected readonly BASE_URL: string) {}

  protected fetch<DataType = any>(endpointUrl: string, requestParams?: Record<string, any> | string, requestInit: RequestInit = {},
    addAccessToken = false): Promise<ApiResponse<DataType>> {
    const accessToken = addAccessToken && this.getAccessToken();
    requestInit.headers = {
      ...requestInit.headers,
      ...(!!accessToken && { [this.REQUEST_HEADERS.AUTHORIZATION]: this.encodeAccessToken(accessToken) })
    };
    return new Promise((resolve, reject) => {
      fetch(this.getRequestUrl(endpointUrl, requestParams), requestInit)
        .then((response: Response) => {
          const { status } = response;
          if (status === 204) {
            resolve({ status });
          } else {
            response.json()
              .then((jsonResponse) => {
                if (response.ok) {
                  resolve({
                    status,
                    data: jsonResponse
                  });
                } else {
                  reject({
                    status,
                    data: jsonResponse
                  });
                }
              })
              .catch((error) => {
                if (response.ok) {
                  resolve({ status });
                } else {
                  reject({ status });
                }
              });
          }
        })
        .catch(reject);
    });
  }

  protected replaceUrlParams(url: string, params: Record<string, string>): string {
    return Object.entries(params).reduce((result: string, [key, value]) => {
      return result.replace(`{${ key }}`, value);
    }, url);
  }

  protected encodeRequestBody(body: Record<string, any>, contentType: string): BodyInit {
    const encodeFn = {
      [this.CONTENT_TYPES.JSON]: () => JSON.stringify(body, (key, value) => (typeof value === 'undefined') ? null : value)
    }[contentType];
    return !!encodeFn ? encodeFn() : undefined;
  }

  private getAccessToken(): string {
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    return store.getters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.token }`];
  }

  private encodeAccessToken(accessToken: string): string {
    return `Bearer ${ accessToken }`;
  }

  private getRequestUrl(endpointUrl: string, params: Record<string, any> | string = {}): string {
    let paramsUrl = '';
    if (typeof params === 'object') {
      Object.entries(params).forEach(([paramId, paramValue]: [string, any], index: number) => {
        paramsUrl += `${ ((index === 0) ? '?' : '&') }${ paramId }=${ encodeURIComponent((paramValue)) }`;
      });
    } else {
      paramsUrl += `/${ params }`;
    }
    let endpointSeparator = '';
    if (!endpointUrl.startsWith('/')) {
      endpointSeparator = '/';
    }
    return `${ this.BASE_URL }${ endpointSeparator }${ endpointUrl }${ paramsUrl }`;
  }

}
